<div class="tooltip-min" *ngIf="showTooltip">
  <div class="tooltip tooltip-show">
    <div class="tooltip-content" style="margin-top: 0px;">
      {{tooltipContent}}
    </div>
  </div>
</div>
